/* eslint-disable import/no-unused-modules */

export const ACTION_INVITE_ACCEPT = 'invite_accept';
export const ACTION_INVITE_SEND = 'invite_send';
export const ACTION_PLAN_SUBSCRIBE = 'plan_subscribe';
export const ACTION_POST_CREATE = 'post_create';
export const ACTION_POST_PUBLISH = 'post_publish';
export const ACTION_POST_READ = 'post_read';
export const ACTION_SEARCH_QUERY = 'search_query';
export const ACTION_SIGNUP_FINISH = 'signup_finish';
export const ACTION_TANDEM_ERROR = 'tandem_error';
export const ACTION_TYPING_APDEX = 'typing_apdex';
export const ACTION_EDITOR_RENDER_DURATION = 'editor_render_duration';
export const ACTION_TOGGLE_POST_COLLAPSE = 'toggle_post_collapse';

export const ACTION_PRICING_MODAL = 'pricing_modal';
export const ACTION_REFERRAL_COPY = 'referral_copy';
export const ACTION_REFERRAL_MODAL = 'referral_modal';

export const CATEGORY_ADMIN = 'admin';
export const CATEGORY_GROWTH = 'growth';
export const CATEGORY_PRODUCT = 'product';
export const CATEGORY_SITE = 'site';
export const CATEGORY_USER = 'user';

export const LAYER = 'frontend';
